module.exports = __webpack_public_path__ + "static/img/23.00740b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/23.png
// module id = J/W0
// module chunks = 35